import { atom } from "recoil";

export const notyStore = atom({
	key: "notyStore",
	default: {
		data: [],
	},
});
